import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { CommonEndpoints } from '@constants/common';
import { lookupAccess, LookupType } from '@constants/lookupTypes';
import { LookupResponse } from '@tamwely-types/common';
import { forkJoin, of, tap } from 'rxjs';

/**
 * @author Khaled Abdullah Alorayir @user korayir>
 * @co-author Abdulrahman Bin Rushud @user arushud>
 */
@Injectable({
  providedIn: 'root',
})
export class LookupService {
  private readonly httpClient = inject(HttpClient);

  lookups: Record<LookupType, LookupResponse[]> = {
    [LookupType.IDENTITY_TYPE]: [],
    [LookupType.FINANCIAL_ENTITY]: [],
    [LookupType.LOAN_TYPE]: [],
    [LookupType.EMPLOYER_SECTOR]: [],
  };

  getLookups(lookupTypes: LookupType[]) {
    return forkJoin(lookupTypes.map((lookupType) => this.getLookup(lookupType)));
  }

  private getLookup(lookupType: LookupType) {
    if (this.lookups[lookupType].length) {
      return of(this.lookups[lookupType]);
    }

    const access = lookupAccess[lookupType];
    const endpoint =
      access === 'PUBLIC'
        ? CommonEndpoints.PUBLIC_LOOKUP(lookupType)
        : CommonEndpoints.PRIVATE_LOOKUP(lookupType);

    return this.httpClient.get<LookupResponse[]>(endpoint).pipe(
      tap((data) => {
        this.lookups[lookupType] = data;
      })
    );
  }
}
